import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/profile/user-1.jpg")